import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.253 7a.67.67 0 0 1-.778.264.7.7 0 0 1-.248-.157l-.754-.76-.886 1.333a.667.667 0 0 1-1.107-.747l1.333-2a.67.67 0 0 1 .779-.264.7.7 0 0 1 .248.158l.753.76.887-1.334a.667.667 0 1 1 1.107.734zm-7.22 2.3H2.7V2.633h-.667a.667.667 0 0 1 0-1.333h12a.667.667 0 1 1 0 1.333h-.666V9.3h.666a.667.667 0 1 1 0 1.333H8.7v.767l3.033 2a.666.666 0 0 1-.366 1.233.63.63 0 0 1-.367-.113L8.7 13v.967a.667.667 0 1 1-1.333 0V13l-2.3 1.52a.63.63 0 0 1-.367.113.667.667 0 0 1-.367-1.22l3.034-2v-.78H2.033a.667.667 0 0 1 0-1.333m2 0h8V2.633h-8z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })